// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class CartAPI extends MainAPI {
	/**
	 * @param petId
	 * @return {object} cart list
	 */
	async getCart(petId, cartDetails) {
		return API.get(`${ENDPOINTS.GET_CART}/${petId}?${queryString.stringify(cartDetails)}`)
	}

	async getPublicCartProductDetails(bundleIds) {
		return API.get(`${ENDPOINTS.GET_PUBLIC_CART}?bundleIds=${JSON.stringify(bundleIds)}`)
	}

	/**
	 * @param petId
	 * @return {object} cart list
	 */
	async getCartCount(petId, cartDetails) {
		return API.get(`${ENDPOINTS.GET_CART}/${petId}/count`, cartDetails)
	}

	/**
	 * @param petId
	 * @param bundleIds
	 * @return No content
	 */
	async deleteCart(petId, bundleIds) {
		return API.put(`${ENDPOINTS.DELETE_CART}/${petId}/delete`, bundleIds)
	}

	/**
	 * @param petId
	 * @param cartDetails
	 * @return No content
	 */
	async putCart(petId, cartDetails) {
		return API.put(`${ENDPOINTS.PUT_CART}/${petId}/update`, cartDetails)
	}

	/**
	 * @param petId
	 * @param cartDetails
	 * @return No content
	 */
	async postCart(petId, cartDetails) {
		return API.post(`${ENDPOINTS.POST_CART}/${petId}`, cartDetails)
	}

	/**
	 * @param bundleId
	 * @return No content
	 */
	async deleteDogCart(bundleId) {
		return API.delete(`${ENDPOINTS.DELETE_DOG_CART}/${bundleId}`)
	}
}

export default new CartAPI()
